import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-[var(--st-border)] py-12 mt-auto">
            <div className="st-container">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">

                    {/* Brand Column */}
                    <div className="col-span-2 md:col-span-1">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-8 h-8 flex items-center justify-center">
                                <svg width="40" height="32" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 sm:w-auto sm:h-auto">
                                    <path d="M5 10 L22 10 L22 5 L27 5 L27 10 L45 10 L45 30 L27 30 L27 35 L22 35 L22 30 L5 30 Z" fill="#6366f1"/>
                                    <circle cx="24.5" cy="10" r="5" fill="#f8fafc"/>
                                    <circle cx="24.5" cy="30" r="5" fill="#f8fafc"/>
                                    <line x1="12" y1="17" x2="18" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                                    <line x1="12" y1="20" x2="20" y2="20" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
                                    <line x1="12" y1="23" x2="16" y2="23" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
                                    <path d="M35 13 L30 20 L35 20 L32 27 L40 18 L35 18 Z" fill="#f59e0b"/>
                                </svg>
                            </div>
                            <span className="font-display font-bold">SuperTicket</span>
                        </div>
                        <p className="text-[var(--st-text-secondary)] text-sm">Tu plataforma de confianza para eventos únicos.</p>
                    </div>

                    {/* Links Columns */}
                    <div>
                        <h4 className="font-semibold mb-4">Explorar</h4>
                        <ul className="space-y-2 text-[var(--st-text-muted)] text-sm">
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Eventos</a></li>
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Categorías</a></li>
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Ciudades</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Organizadores</h4>
                        <ul className="space-y-2 text-[var(--st-text-muted)] text-sm">
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Crear Evento</a></li>
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Precios</a></li>
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Recursos</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Soporte</h4>
                        <ul className="space-y-2 text-[var(--st-text-muted)] text-sm">
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Centro de Ayuda</a></li>
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Contacto</a></li>
                            <li><a href="/" className="hover:text-[var(--st-text-primary)] transition-colors">Términos</a></li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-[var(--st-border)] flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-[var(--st-text-secondary)] text-sm">© {new Date().getFullYear()} SuperTicket. Todos los derechos reservados.</p>
                    <div className="flex gap-4">
                        {/* Social Icons */}
                        <a href="/" className="text-[var(--st-text-secondary)] hover:text-[var(--st-accent-primary)] transition-colors">Instagram</a>
                        <a href="/" className="text-[var(--st-text-secondary)] hover:text-[var(--st-accent-primary)] transition-colors">Twitter</a>
                        <a href="/" className="text-[var(--st-text-secondary)] hover:text-[var(--st-accent-primary)] transition-colors">LinkedIn</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;